import { useState } from 'react';
import { Button, FormControl, FormLabel, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const NewItemDialog = ({ title, onSave, onClose, open }) => {
  const [id, setId] = useState('');
  const [name, setName] = useState('');

  const handleSave = () => {
    onSave(id, name);
    setId('');
    setName('');
  };

  const handleClose = () => {
    onClose();
    setId('');
    setName('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <FormLabel>ID</FormLabel>
          <TextField value={id} onChange={(e) => setId(e.target.value)} placeholder="Enter ID" size="small" />
        </FormControl>
        <FormControl fullWidth>
          <FormLabel>Name</FormLabel>
          <TextField value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter name" size="small" />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSave}>
          Add
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewItemDialog;
